import { render } from "./ModalModifierJeu.vue?vue&type=template&id=2cb3fa68"
import script from "./ModalModifierJeu.vue?vue&type=script&lang=js"
export * from "./ModalModifierJeu.vue?vue&type=script&lang=js"

import "./ModalModifierJeu.vue?vue&type=style&index=0&id=2cb3fa68&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__